/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Checkout_Return_To_SignupInputs */



/**
* | output |
* | --- |
* | "Return to Signup" |
*
* @param {Creator_Checkout_Return_To_SignupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_checkout_return_to_signup = /** @type {((inputs?: Creator_Checkout_Return_To_SignupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Checkout_Return_To_SignupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retourner a l'inscription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zurück zur Anmeldung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Torna alla registrazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вернуться к регистрации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Regresar a Registrarse")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("返回注册页面")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サインアップに戻る")
	if (locale === "hi") return /** @type {LocalizedString} */ ("साइनअप पर वापस जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Voltar ao cadastro")
	return /** @type {LocalizedString} */ ("Return to Signup")
});